module.exports = __webpack_public_path__ + "static/img/map1.919c803.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/map1.jpg
// module id = BhHe
// module chunks = 1